<template>
    <div class="container-fluid no-min-height">
        <div class="row">
            <div class="col-12 col-lg-6 offset-lg-3">
                <h2>
                    Aanvraagformulier voor decanen voor voorlichting van het
                    Horizon College
                </h2>
                <p>* = verplicht</p>

                <div class="position-relative">
                    <transition name="fade">
                        <form v-if="!success" key="form">
                            <TextInput
                                v-model="form.schoolName"
                                v-validate="'required'"
                                data-vv-as="Naam school"
                                :disabled="processing"
                                :error="errors.first('schoolName')"
                                :name="'schoolName'"
                                :label="'Naam school *'"
                                :placeholder="'Naam school'"
                            ></TextInput>

                            <TextInput
                                v-model="form.address"
                                v-validate="'required'"
                                data-vv-as="Adres"
                                :disabled="processing"
                                :error="errors.first('address')"
                                :name="'address'"
                                :label="'Adres school *'"
                                :placeholder="'Adres school'"
                            ></TextInput>

                            <TextInput
                                v-model="form.zip"
                                v-validate="'required'"
                                data-vv-as="Postcode en plaats"
                                :disabled="processing"
                                :error="errors.first('zip')"
                                :name="'zip'"
                                :label="'Postcode en plaats *'"
                                :placeholder="'Postcode en plaats'"
                            ></TextInput>

                            <TextInput
                                v-model="form.contactName"
                                v-validate="'required'"
                                data-vv-as="Naam contactpersoon"
                                :disabled="processing"
                                :error="errors.first('contactName')"
                                :name="'contactName'"
                                :label="'Naam contactpersoon *'"
                                :placeholder="'Naam contactpersoon'"
                            ></TextInput>

                            <TextInput
                                v-model="form.contactEmail"
                                v-validate="'email'"
                                data-vv-as="E-mailadres"
                                :disabled="processing"
                                :error="errors.first('contactEmail')"
                                :name="'contactEmail'"
                                :label="'E-mailadres'"
                                :placeholder="'naam@provider.nl'"
                                :type="'email'"
                            ></TextInput>

                            <TextInput
                                v-model="form.contactPhone"
                                v-validate="{
                                    max: 11,
                                    regex: /\d{3,4}[ -]{0,1}\d{6,7}/
                                }"
                                data-vv-as="Telefoonnummer"
                                :disabled="processing"
                                :error="errors.first('contactPhone')"
                                :name="'contactPhone'"
                                :label="'Telefoonnummer'"
                                :placeholder="'0612345678'"
                                :type="'tel'"
                            ></TextInput>

                            <TextInput
                                v-model="form.date"
                                v-validate="'required'"
                                data-vv-as="Datum voorlichting"
                                :disabled="processing"
                                :error="errors.first('date')"
                                :name="'date'"
                                :label="'Datum voorlichting *'"
                                :placeholder="'Bijvoorbeeld: 7-10-2020'"
                            ></TextInput>

                            <TextInput
                                v-model="form.time"
                                v-validate="'required'"
                                data-vv-as="Tijdstip"
                                :disabled="processing"
                                :error="errors.first('time')"
                                :name="'time'"
                                :label="'Tijdstip *'"
                                :placeholder="
                                    'Bijvoorbeeld: van 13.00 tot 15.00 uur'
                                "
                            ></TextInput>
                            <div class="row mb-2 mt-2">
                                <p class="col-12">Soort voorlichting *</p>
                                <div
                                    v-for="(option,
                                    index) in informationTypeOptions"
                                    :key="index"
                                    class="col-12 col-md-6 checkbox-input"
                                >
                                    <label>
                                        <input
                                            v-model="form.informationType"
                                            v-validate="'required|minLength:1'"
                                            type="checkbox"
                                            class="checkbox-input__input"
                                            name="informationType"
                                            :value="option.name"
                                        />
                                        {{ option.name }}
                                    </label>
                                </div>
                                <p v-if="errors.first('informationType')">
                                    U dient een waarde in te voeren
                                </p>
                            </div>

                            <div class="row mb-2 mt-2">
                                <p class="col-12">Doelgroep *</p>
                                <div
                                    v-for="(option,
                                    index) in targetAudienceOptions"
                                    :key="index"
                                    class="col-12 col-md-4 checkbox-input"
                                >
                                    <label>
                                        <input
                                            v-model="form.targetAudience"
                                            v-validate="'required|minLength:1'"
                                            type="radio"
                                            class="checkbox-input__input"
                                            name="targetAudience"
                                            :value="option.name"
                                        />
                                        {{ option.name }}
                                    </label>
                                </div>
                                <p v-if="errors.first('targetAudience')">
                                    U dient een waarde in te voeren
                                </p>
                            </div>

                            <div class="row mb-2">
                                <p class="col-12">Leerjaar *</p>
                                <div
                                    v-for="(option,
                                    index) in learningYearOptions"
                                    :key="index"
                                    class="col-12 col-md-3 checkbox-input"
                                >
                                    <label>
                                        <input
                                            v-model="form.learningYear"
                                            v-validate="'required|minLength:1'"
                                            type="checkbox"
                                            class="checkbox-input__input"
                                            name="learningYear"
                                            :value="option.name"
                                        />
                                        {{ option.name }}
                                    </label>
                                </div>
                                <p v-if="errors.first('learningYear')">
                                    U dient een waarde in te voeren
                                </p>
                            </div>

                            <div class="row mb-2">
                                <p class="col-12">Niveau *</p>
                                <div
                                    v-for="(option, index) in levelOptions"
                                    :key="index"
                                    class="col-12 col-md-4 checkbox-input"
                                >
                                    <label>
                                        <input
                                            v-model="form.level"
                                            v-validate="'required|minLength:1'"
                                            type="checkbox"
                                            class="checkbox-input__input"
                                            name="level"
                                            :value="option.name"
                                        />
                                        {{ option.name }}
                                    </label>
                                </div>
                                <p v-if="errors.first('level')">
                                    U dient een waarde in te voeren
                                </p>
                            </div>

                            <div class="row mb-2">
                                <p class="col-12">
                                    Waarover wilt u dat de voorlichting gaat?
                                    Aankruisen wat van toepassing is:
                                </p>
                                <div
                                    v-for="(option, index) in directionOptions"
                                    :key="index"
                                    class="col-12 col-md-4 checkbox-input"
                                >
                                    <label>
                                        <input
                                            v-model="form.direction"
                                            type="checkbox"
                                            class="checkbox-input__input"
                                            name="direction"
                                            :value="option"
                                        />
                                        {{ option }}
                                    </label>
                                </div>
                            </div>

                            <TextAreaInput
                                v-model="form.comments"
                                data-vv-as="Bericht"
                                :disabled="processing"
                                :error="errors.first('comments')"
                                :name="'comments'"
                                :label="'Bericht'"
                                :rows="5"
                                :placeholder="'Vul hier je bericht in...'"
                            ></TextAreaInput>

                            <button
                                class="btn btn-primary float-right mb-1"
                                :disabled="processing"
                                @click.prevent="validateAndSubmit"
                            >
                                verstuur
                            </button>
                        </form>
                        <div v-else key="successMessage" class="rte">
                            Bedankt voor uw aanvraag. Wij hebben deze in goede
                            orde ontvangen. Wij zullen zo snel mogelijk contact
                            met u opnemen.
                        </div>
                    </transition>
                    <div
                        v-if="!success && error"
                        key="errorMessage"
                        class="rte form-failed"
                        v-html="errorMessageFromApi"
                    ></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Vue from 'vue';
import Axios from 'axios';
import { VueReCaptcha } from 'vue-recaptcha-v3';
import FormSubmissionMixin from '@/js/mixins/form-submission-mixin.js';
import TextInput from '@/components/form/text-input';
import TextAreaInput from '@/components/form/textarea-input';
import VeeValidate from 'vee-validate';

Vue.use(VueReCaptcha, { siteKey: '6LfB5cMUAAAAAOnv1Nn1d1neosmH_X5xVuUx0zu4' });
Vue.use(VeeValidate);

VeeValidate.Validator.extend('minLength', {
    getMessage(field, [length]) {
        return `At least ${length} items must be selected.`;
    },
    validate(value, [length]) {
        return value.length >= length;
    }
});

export default {
    components: {
        TextInput,
        TextAreaInput
    },

    mixins: [FormSubmissionMixin],

    props: {
        formData: {
            type: Object,
            default() {
                return {};
            }
        }
    },

    data() {
        return {
            form: {
                schoolName: '',
                address: '',
                zip: '',
                contactName: '',
                contactEmail: '',
                contactPhone: '',
                date: '',
                time: '',
                informationType: [],
                targetAudience: [],
                learningYear: [],
                level: [],
                direction: [],
                comments: ''
            },
            informationTypeOptions: [
                {
                    name: 'Specifiek in een lokaal',
                    checked: false
                },
                {
                    name: 'Markt',
                    checked: false
                },
                {
                    name: 'Centrale voorlichting',
                    checked: false
                },
                {
                    name: 'Online',
                    checked: false
                }
            ],
            targetAudienceOptions: [
                {
                    name: 'Leerlingen zonder ouders',
                    checked: false
                },
                {
                    name: 'Leerlingen met ouders',
                    checked: false
                }
            ],
            learningYearOptions: [
                {
                    name: '3',
                    checked: false
                },
                {
                    name: '4',
                    checked: false
                }
            ],
            levelOptions: [
                {
                    name: 'Basis',
                    checked: false
                },
                {
                    name: 'Kader',
                    checked: false
                },
                {
                    name: 'GL',
                    checked: false
                },
                {
                    name: 'TL',
                    checked: false
                },
                {
                    name: 'Mavo',
                    checked: false
                }
            ],
            directionOptions: [],
            postUrl: '/api/InformationRequestFormApi/Submit'
        };
    },

    computed: {
        errorMessageFromApi() {
            if (!this.errorMessage.length) {
                return this.formData.errorMessage;
            }

            return this.errorMessage;
        }
    },

    created() {
        this.getDirections();
    },

    methods: {
        getDirections() {
            const url = '/api/InformationRequestFormApi/GetDirectionTypes';
            Axios({
                method: 'get',
                url: url
            })
                .then(response => {
                    if (!response.data === null) {
                        return false;
                    }

                    this.directionOptions = response.data;
                    return true;
                })
                .catch(() => false);
        }
    }
};
</script>

<style lang="scss">
.grecaptcha-badge {
    display: none;
}

.fade-enter-active,
.fade-leave-active {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    transition: opacity 0.5s $easeOutQuad, transform 0.5s $easeOutQuad;
}
.fade-enter {
    opacity: 0;
    transform: translateX(-100%);
}

.fade-leave-to {
    opacity: 0;
    transform: translateX(100%);
}
</style>
